// extracted by mini-css-extract-plugin
export default {"avatar":"IDSelectItem_avatar__+QWw6","label":"IDSelectItem_label__zARbI","title":"IDSelectItem_title__5x2en","subtitle":"IDSelectItem_subtitle__atrdJ"};